// @ts-strict-ignore
import type { SelectableStatus } from './status';

interface StatusReasonOption {
  key: string;
  value: SelectableStatus | string;
  label: SelectableStatus | string;
}
export const mapReasonToOption = (
  trxDescriptionsByStatus: object = {},
  status: SelectableStatus | string = '',
): Array<StatusReasonOption> => {
  if (Object.keys(trxDescriptionsByStatus).includes(status)) {
    return trxDescriptionsByStatus[status];
  }
  return [];
};

